import React from "react";
import { Link } from "react-router-dom";

function Menu() {
  return (
    <nav style={{ backgroundColor: "#333", padding: "10px", color: "white" }}>
      <ul style={{ listStyle: "none", display: "flex", gap: "10px" }}>
        <li>
          <Link to="/" style={{ color: "white", textDecoration: "none" }}>
            Strona główna
          </Link>
        </li>
        <li>
          <Link to="/hotel/2/ee8bf7ab-2dbe-4206-9239-9a09e930963d/hotel_tres_torres/tfloors" style={{ color: "white", textDecoration: "none" }}>
            Widok Pięter
          </Link>
        </li>
        <li>
          <Link to="/hotel/2/ee8bf7ab-2dbe-4206-9239-9a09e930963d/hotel_tres_torres/floors">Tres Torres</Link>
        </li>
      </ul>
    </nav>
  );
}

export default Menu;
